import * as requests from '../api-request'

// Many FeatureRating components mount at once on editor pageload (one per
// chat item / report), and each used to issue its own
// GET features_rating?aiRequestUuid=... request. Sentry flags this as an
// N+1 API call pattern (NOLAN-STUDIO-17Y). Coalesce lookups that arrive in
// the same short window into a single batched request per featureName.
const BATCH_WINDOW_MS = 50
const pendingBatches = new Map()

const flushRatingBatch = async (featureName) => {
  const batch = pendingBatches.get(featureName)
  if (!batch) return
  pendingBatches.delete(featureName)
  const uuids = [...batch.keys()]
  try {
    const queryString = new URLSearchParams({
      aiRequestUuids: uuids.join(','),
      featureName
    })
    const ratings = await requests.toJSON('GET', `features_rating?${queryString}`)
    const ratingsByUuid = {}
    for (const rating of ratings || []) {
      ratingsByUuid[rating.ai_request_uuid] = rating
    }
    for (const [uuid, callbacks] of batch) {
      callbacks.forEach(({ resolve }) => resolve(ratingsByUuid[uuid] || null))
    }
  } catch (error) {
    for (const callbacks of batch.values()) {
      callbacks.forEach(({ reject }) => reject(error))
    }
  }
}

export const getRating = ({ aiRequestUuid, featureName }) => {
  return new Promise((resolve, reject) => {
    let batch = pendingBatches.get(featureName)
    if (!batch) {
      batch = new Map()
      pendingBatches.set(featureName, batch)
      setTimeout(() => flushRatingBatch(featureName), BATCH_WINDOW_MS)
    }
    if (!batch.has(aiRequestUuid)) batch.set(aiRequestUuid, [])
    batch.get(aiRequestUuid).push({ resolve, reject })
  })
}

export const addRating = async (data) => {
  return requests.toJSON('POST', 'features_rating', data)
}
